import script from "./EstimateReceivedPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./EstimateReceivedPreview.vue?vue&type=script&lang=ts&setup=true"

import "./EstimateReceivedPreview.vue?vue&type=style&index=0&id=5cb64a0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb64a0c"]])

export default __exports__